import { StateProvider, StateService, Transition } from '@uirouter/angularjs';
import { PaymentService } from '../../core/services/payment/payment.service';
import { Helpers } from '../../helpers';
import { JobRankService } from '../../core/services/job-rank/job-rank.service';
import { JobPositionService } from '../../core/services/job-position/job-position.service';
import { AuthService } from '../../core/services/auth/auth.service';

export const dashboardStateName = 'app.dashboard';

export function dashboardRoutesConfig( $stateProvider: StateProvider ) {

  $stateProvider
    .state(dashboardStateName, {
      abstract: true,
      component: 'dashboard',
      resolve: [
        /*{
          provide: 'profile',
          deps: [ '$state', 'ProfileService' ],
          useFactory: ( $state: StateService, profileService: ProfileService ) => {
            return profileService.getProfile()
              .catch(( err ) => {
                console.log(err);
                $state.go('logout');
              });
          }
        },*/
        {
          provide: 'balance',
          deps: [ '$state', 'PaymentService' ],
          useFactory: ( $state: StateService, paymentService: PaymentService ) => {
            return paymentService.getBalance()
              .then((test) => console.log(test))
              .catch(( err ) => {
                console.log(err);
              });
          }
        },
        {
          provide: 'INITIAL_DATA',
          deps: [
            'JobRankService',
            'JobPositionService'
          ],
          useFactory: ( jobService: JobRankService,
                        positionService: JobPositionService ) => {
            return Promise.all([
              jobService.fetchVesselJobs(),
              positionService.fetchAllPositions()
            ])
              .catch(( err ) => {
                console.log(err);
                throw err;
              });
          }
        }
      ]
    })
    .state(`${dashboardStateName}.profile.**`, {
      url: '/profile',
      lazyLoad: async ( transition: Transition ) => {
        Helpers.setTransitionBarState(transition, true);
        const { ProfileModule } = await import('../profile/profile.module');
        Helpers.setTransitionBarState(transition, false);
        return Helpers.oclazyloadFromTransition(transition).inject(ProfileModule.name);
      },
    })
    .state(`${dashboardStateName}.cv.**`, {
      url: '/cv',
      lazyLoad: async ( transition: Transition ) => {
        Helpers.setTransitionBarState(transition, true);
        const { CvModule } = await import('../cv/cv.module');
        Helpers.setTransitionBarState(transition, false);
        return Helpers.oclazyloadFromTransition(transition).inject(CvModule.name);
      }
    })
    // .state(`${dashboardStateName}.advanced-cv`, {
    //   url: '/advanced-cv',
    //   lazyLoad: async ( transition: Transition ) => {
    //       Helpers.setTransitionBarState(transition, true);
    //       const { AdvancedCvModule } = await import('../../ui/advanced-cv/advanced-cv.module');
    //       Helpers.setTransitionBarState(transition, false);
    //       return Helpers.oclazyloadFromTransition(transition).inject(AdvancedCvModule);
    //   }
    // })
    .state(`${dashboardStateName}.smart-services.**`, {
      url: '/smart-services',
      lazyLoad: async ( transition: Transition ) => {
        Helpers.setTransitionBarState(transition, true);
        const { SmartServicesModule } = await import('../smart-services/smart-services.module');
        Helpers.setTransitionBarState(transition, false);
        return Helpers.oclazyloadFromTransition(transition).inject(SmartServicesModule.name);
      }
    })
    .state(`${dashboardStateName}.top-vacancy.**`, {
      url: '/top-vacancy',
      lazyLoad: async ( transition: Transition ) => {
        Helpers.setTransitionBarState(transition, true);
        const { TopVacancyModule } = await import('../top-vacancy/top-vacancy.module');
        Helpers.setTransitionBarState(transition, false);
        return Helpers.oclazyloadFromTransition(transition).inject(TopVacancyModule.name);
      }
    })
    .state(`${dashboardStateName}.posted-vacancy.**`, {
      url: '/posted-vacancy',
      lazyLoad: async ( transition: Transition ) => {
        Helpers.setTransitionBarState(transition, true);
        const { PostedVacancyModule } = await import('../posted-vacancy/posted-vacancy.module');
        Helpers.setTransitionBarState(transition, false);
        return Helpers.oclazyloadFromTransition(transition).inject(PostedVacancyModule.name);
      }
    })
    .state(`${dashboardStateName}.top-candidate.**`, {
      url: '/top-candidate',
      lazyLoad: async ( transition: Transition ) => {
        Helpers.setTransitionBarState(transition, true);
        const { TopCandidateModule } = await import('../top-candidate/top-candidate.module');
        Helpers.setTransitionBarState(transition, false);
        return Helpers.oclazyloadFromTransition(transition).inject(TopCandidateModule.name);
      }
    })
    .state(`${dashboardStateName}.top-cv.**`, {
      url: '/top-cv',
      lazyLoad: async ( transition: Transition ) => {
        Helpers.setTransitionBarState(transition, true);
        const { TopCvModule } = await import('../top-cv/top-cv.module');
        Helpers.setTransitionBarState(transition, false);
        return Helpers.oclazyloadFromTransition(transition).inject(TopCvModule.name);
      }
    })
    .state(`${dashboardStateName}.contact-list.**`, {
      url: '/contact-list',
      lazyLoad: async ( transition: Transition ) => {
        Helpers.setTransitionBarState(transition, true);
        const { ContactListModule } = await import('../contact-list/contact-list.module');
        Helpers.setTransitionBarState(transition, false);
        return Helpers.oclazyloadFromTransition(transition).inject(ContactListModule.name);
      }
    })
    .state(`${dashboardStateName}.contact.**`, {
      url: '/contact/:contact',
      component: 'contactListVacancies',
      resolve: {
        $title: () => 'Contact'
      },
      lazyLoad: async ( transition: Transition ) => {
        Helpers.setTransitionBarState(transition, true);
        const { ContactListModule } = await import('../contact-list/contact-list.module');
        Helpers.setTransitionBarState(transition, false);
        return Helpers.oclazyloadFromTransition(transition).inject(ContactListModule.name);
      }
    })
    .state(`${dashboardStateName}.mailbox.**`, {
      url: '/mailbox',
      lazyLoad: async ( transition: Transition ) => {
        Helpers.setTransitionBarState(transition, true);
        const { MailboxModule } = await import('../mailbox/mailbox.module');
        Helpers.setTransitionBarState(transition, false);
        return Helpers.oclazyloadFromTransition(transition).inject(MailboxModule.name);
      }
    })
    .state(`${dashboardStateName}.chat.**`, {
      url: '/chat',
      lazyLoad: async ( transition: Transition ) => {
        Helpers.setTransitionBarState(transition, true);
        const { ChatModule } = await import('../chat/chat.module');
        Helpers.setTransitionBarState(transition, false);
        return Helpers.oclazyloadFromTransition(transition).inject(ChatModule.name);
      }
    })
    .state(`${dashboardStateName}.faq`, {
      url: '/faq',
      component: 'faq',
      resolve: {
        $title: () => 'F.A.Q.'
      },
      lazyLoad: async ( transition: Transition ) => {
        Helpers.setTransitionBarState(transition, true);
        const { FaqModule } = await import('../faq/faq.module');
        Helpers.setTransitionBarState(transition, false);
        return Helpers.oclazyloadFromTransition(transition).inject(FaqModule.name);
      }
    })
    .state(`${dashboardStateName}.top-employer.**`, {
      url: '/top-employer',
      lazyLoad: async ( transition: Transition ) => {
        Helpers.setTransitionBarState(transition, true);
        const { TopEmployerModule } = await import('../top-employer/top-employer.module');
        Helpers.setTransitionBarState(transition, false);
        return Helpers.oclazyloadFromTransition(transition).inject(TopEmployerModule.name);
      }
    })
    .state(`${dashboardStateName}.employer.**`, {
      url: '/employer/:employer',
      component: 'contactListVacancies',
      resolve: {
        $title: () => 'Employer'
      },
      lazyLoad: async ( transition: Transition ) => {
        Helpers.setTransitionBarState(transition, true);
        const { ContactListModule } = await import('../contact-list/contact-list.module');
        Helpers.setTransitionBarState(transition, false);
        return Helpers.oclazyloadFromTransition(transition).inject(ContactListModule.name);
      }
    })
    .state(`${dashboardStateName}.finance.**`, {
      url: '/finance',
      lazyLoad: async ( transition: Transition ) => {
        Helpers.setTransitionBarState(transition, true);
        const { FinanceModule } = await import('../finance/finance.module');
        Helpers.setTransitionBarState(transition, false);
        return Helpers.oclazyloadFromTransition(transition).inject(FinanceModule);
      }
    })
    .state(`${dashboardStateName}.business-status.**`, {
      url: '/business-status',
      lazyLoad: async ( transition: Transition ) => {
        Helpers.setTransitionBarState(transition, true);
        const { BusinessStatusModule } = await import('../business-status/business-status.module');
        Helpers.setTransitionBarState(transition, false);
        return Helpers.oclazyloadFromTransition(transition).inject(BusinessStatusModule);
      }
    })
    .state(`${dashboardStateName}.playground.**`, {
      url: '/playground',
      lazyLoad: async ( transition: Transition ) => {
        Helpers.setTransitionBarState(transition, true);
        const { PlaygroundModule } = await import('../playground/playground.module');
        Helpers.setTransitionBarState(transition, false);
        return Helpers.oclazyloadFromTransition(transition).inject(PlaygroundModule.name);
      }
    })
    .state(`${dashboardStateName}.small-business.**`, {
      url: '/small-business',
      lazyLoad: async ( transition: Transition ) => {
        Helpers.setTransitionBarState(transition, true);
        const { SmallBusinessModule } = await import('../small-business/small-business.module');
        Helpers.setTransitionBarState(transition, false);
        return Helpers.oclazyloadFromTransition(transition).inject(SmallBusinessModule.name);
      }
    })
    .state(`${dashboardStateName}.create-vacancy.**`, {
      url: '/create-vacancy',
      lazyLoad: async ( transition: Transition ) => {
        Helpers.setTransitionBarState(transition, true);
        const { PostedVacancyModule } = await import('../posted-vacancy/posted-vacancy.module');
        Helpers.setTransitionBarState(transition, false);
        return Helpers.oclazyloadFromTransition(transition).inject(PostedVacancyModule.name);
      }
    })
    .state(`${dashboardStateName}.applicants.**`, {
      url: '/applicants/:vacancyId',
      component: 'postedVacancyApplicants',
      resolve: {
        $title: () => 'Vacancy Applicants'
      },
      lazyLoad: async ( transition: Transition ) => {
        Helpers.setTransitionBarState(transition, true);
        const { PostedVacancyModule } = await import('../posted-vacancy/posted-vacancy.module');
        Helpers.setTransitionBarState(transition, false);
        return Helpers.oclazyloadFromTransition(transition).inject(PostedVacancyModule.name);
      }
    })
    .state(`${dashboardStateName}.edit-vacancy`, {
      url: '/edit-vacancy/:vacancyId',
      component: 'postedVacancyCreate',
      params: {
        vacancyId: '',
        vacancy: '',
        edit: true
      },
      resolve: {
        $title: () => 'Vacancy Applicants'
      },
      lazyLoad: async ( transition: Transition ) => {
        Helpers.setTransitionBarState(transition, true);
        const { PostedVacancyModule } = await import('../posted-vacancy/posted-vacancy.module');
        Helpers.setTransitionBarState(transition, false);
        return Helpers.oclazyloadFromTransition(transition).inject(PostedVacancyModule.name);
      }
    });
}

dashboardRoutesConfig.$inject = [
  '$stateProvider'
];



// WEBPACK FOOTER //
// ./app/states/dashboard/dashboard-routing.ts